import { OptaSDCompetitionsMap } from '@app/services/opta/constants/competitionConstants';

export const isOptaSDCompetition = (competitionId: string): boolean => [
  OptaSDCompetitionsMap.Primavera as string,
  OptaSDCompetitionsMap.Primavera2 as string,
  OptaSDCompetitionsMap.UefaYouthLeague as string,
  OptaSDCompetitionsMap.FuturoSeriaC as string,
  OptaSDCompetitionsMap.FuturoCoppaItalia as string,
].includes(competitionId);
